import { render, staticRenderFns } from "./Preview.vue?vue&type=template&id=97bcfa1e&scoped=true"
import script from "./Preview.vue?vue&type=script&lang=ts"
export * from "./Preview.vue?vue&type=script&lang=ts"
import style0 from "./Preview.vue?vue&type=style&index=0&id=97bcfa1e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97bcfa1e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('97bcfa1e')) {
      api.createRecord('97bcfa1e', component.options)
    } else {
      api.reload('97bcfa1e', component.options)
    }
    module.hot.accept("./Preview.vue?vue&type=template&id=97bcfa1e&scoped=true", function () {
      api.rerender('97bcfa1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/documents/Preview.vue"
export default component.exports